var wpdmCategories = [];
class Util{
    constructor(){

    }

    static hexToRgba(hex, alpha) {
        if(!hex || hex === 'transparent') return  'transparent';
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        const rgba = result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: alpha/100
        } : null;
        return "rgba( " + rgba.r + ", " + rgba.g + ", " + rgba.b + ", " + rgba.a + ")";
    }

    static defaultColor(){
        /* Default colors */
        const defaultColors = [
            { color: '#ffffff', name: 'white' },
            { color: '#392F43', name: 'black' },
            { color: '#3373dc', name: 'royal blue' },
            { color: '#209cef', name: 'sky blue' },
            { color: '#2BAD59', name: 'green' },
            { color: '#ff3860', name: 'pink' },
            { color: '#7941b6', name: 'purple' },
            { color: '#F7812B', name: 'orange' },
            { color: 'transparent', name: 'Transparent' },
        ];

        return defaultColors;
    }

    static loadCategories(){
        wp.apiFetch({path: "/wpdm/v1/categories"}).then(categories => {
            wpdmCategories.push({label: "Select a Category", value: 0});
            jQuery.each( categories, function( key, val ) {
                wpdmCategories.push({label: val.label, value: val.id});
            });

        });
    }
}

Util.loadCategories();

export default Util;
